export const paymentAccountsFormatted = (paymentAccounts) => paymentAccounts.map(acct => {
  let display = `${acct.BankName}, ${acct.MaskedBankAccountNumber}`;

  if (acct.Nickname && acct.Nickname.length > 0) {
    display = `${acct.Nickname}, ${acct.MaskedBankAccountNumber}`;
  }

  // allways add the account type
  display = `${display}, ${acct.BankAccountType}`;

  return {
    value: acct.BankAccountId,
    display,
  };
});